import "core-js/modules/es.number.constructor";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { broadMake } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewCom } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom],
  props: {
    propsData: Object
  },
  data: function data() {
    var _this = this;

    var validateVerRange = function validateVerRange(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }

      if (!/^\d+$/.test(value)) {
        callback(new Error(_this.$t('versionMustBeNumber')));
        return;
      }

      var numValue = Number(value);

      if (numValue < 1 || numValue > 1000) {
        callback(new Error(_this.$t('versionRangeTip')));
      } else {
        callback();
      }
    };

    return {
      dialogShow: false,
      isModify: false,
      paramsData: {
        user: '',
        ver: '',
        broad_name: ''
      },
      rules: {
        user: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        broad_name: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        ver: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }, {
          validator: validateVerRange,
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      this.isModify = false;

      if (data) {
        this.isModify = true;
        this.paramsData = _objectSpread({}, data);
      }

      this.dialogShow = true;
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        user: '',
        ver: '',
        broad_name: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.paramsData));
          broadMake(_objectSpread(_objectSpread({}, _this2.paramsData), {}, {
            env_id: _this2.propsData.env_id
          })).then(function (res) {
            if (res.status == 200) {
              _this2.$message({
                message: _this2.$t('operationSuccess'),
                type: 'success'
              });

              _this2.dialogShow = false;

              _this2.$emit('change', data.uids);
            }
          });
        }
      });
    }
  }
};